import styled from 'styled-components';

import { style } from './Field';

export const FormlessField = styled.input`
	${style};
	width: 100%;
`;
